import { Box, Button } from "@mui/material";

import { useTranslation } from "@/translations";

import { CalendarNavigationButton } from "./components/navigation-button/CalendarNavigationButton";

interface Props {
  onPrevClick: () => void;
  onNextClick: () => void;
  onTodayClick: () => void;
  previousLabel: string;
  nextLabel: string;
}

export function CalendarNavigation({ onPrevClick, onNextClick, onTodayClick, previousLabel, nextLabel }: Props) {
  const { t } = useTranslation();

  return (
    <Box display="flex" alignItems="stretch" gap={1} height={"100%"}>
      <CalendarNavigationButton
        onPrevClick={onPrevClick}
        onNextClick={onNextClick}
        previousLabel={previousLabel}
        nextLabel={nextLabel}
      />
      <Button
        size="small"
        variant="contained"
        onClick={onTodayClick}
        sx={(theme) => ({
          backgroundColor: "#fff !important",
          color: `${theme.palette.text.primary} !important`,
          border: `1px solid ${theme.palette.action.active} !important`,
          "&:hover": {
            border: `1px solid ${theme.palette.action.active}`,
          },
        })}
        aria-label={t("calendar.today")}
      >
        {t("calendar.today")}
      </Button>
    </Box>
  );
}
